import React, { useEffect } from "react";
import ScrollToBottom, { useScrollToBottom } from "react-scroll-to-bottom";

// import * as Scroll from 'react-scroll';
import "./ListWrapper.scss";

interface ScrollBridgeProps {
  onScrollFnReady: (fn: (options?: { behavior?: "auto" | "smooth" }) => void) => void;
}

function ScrollToBottomBridge({ onScrollFnReady }: ScrollBridgeProps) {
  const scrollToBottom = useScrollToBottom();
  useEffect(() => {
    onScrollFnReady(scrollToBottom);
  }, [scrollToBottom, onScrollFnReady]);
  return null;
}

export default class ListWrapper extends React.Component<any> {
  private scrollToBottomFn?: (options?: { behavior?: "auto" | "smooth" }) => void;

  public setPositionToBottom(): void {
    this.scrollToBottomFn?.({ behavior: "auto" });
  }

  private onScrollFnReady = (fn: (options?: { behavior?: "auto" | "smooth" }) => void): void => {
    this.scrollToBottomFn = fn;
  };

  render() {
    return (
      <ScrollToBottom
        className="scc-ListWrapper"
        followButtonClassName="scc-SwivlFollowButton"
        initialScrollBehavior="auto"
        scrollViewClassName="scc-scrollView"
      >
        <ScrollToBottomBridge onScrollFnReady={this.onScrollFnReady} />
        <>{this.props.children}</>
      </ScrollToBottom>
    );
  }
}
